import { render, staticRenderFns } from "./VxTrExpand.vue?vue&type=template&id=35bf4a7c"
import script from "./VxTrExpand.vue?vue&type=script&lang=js"
export * from "./VxTrExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports